/* global CDN */
import _ from 'lodash';
import isArray from 'lodash/isArray';
import { Howl, Howler } from 'howler';

Howler.volume(0.5);
const audioCtx = Howler.ctx ? Howler.ctx : null;

const Audio = function (url, opts) {
    this.unlocked = false;

    let src = [`${CDN}${url}`];
    if (isArray(url)) {
        src = url.map(path => (
            `${CDN}${path}`
        ));
    }

    this.url = url;
    this.options = _.extend({
        src,
        // onend: () => {
        //     console.log('Finished!');
        // },
        loop: false,
        useAudioContext: true,
        volume: 0.2,
        autoplay: false,
        onfade: (id) => {
            // console.log('the end of fade', id);
            if (this.howl !== null && this.howl.volume(id) === 0) {
                this.howl.stop(id);
            }
        },
        // onstop: (id) => {
        //     console.log('stopped', id);
        // },
    }, opts);

    this.options.channel = null;
    this.howl = new Howl(this.options);

    return this;
};

Audio.prototype.play = function (index) {
    this.howl.play();
};

Audio.prototype.isPlaying = function (index) {
    return this.howl.playing();
};

Audio.prototype.volume = function (volume) {
    this.howl.volume(volume);
};

Audio.prototype.pause = function (index) {
    this.howl.pause();
};

Audio.prototype.stop = function (index) {
    this.howl.stop();
};

Audio.prototype.mute = function (muted) {
    if (muted === true) {
        this.fadeOut(0);
    } else {
        this.fadeIn(0.2);
    }
    // this.howl.mute(muted);
};

Audio.prototype.fadeIn = function (endVolume = 0.5) {
    if (!this.howl.playing()) {
        this.volume(0);
        this.play();
    }
    this.howl.fade(0, endVolume, 3);
};

Audio.prototype.fadeOut = function (endVolume = 0) {
    const startVolume = this.howl.volume();
    this.howl.fade(startVolume, endVolume, 3);
};

Audio.prototype.fadeInFast = function (endVolume = 0.5) {
    if (!this.howl.playing()) {
        this.volume(0);
        this.play();
    }
    this.howl.fade(0, endVolume, 1);
};

Audio.prototype.fadeOutFast = function (endVolume = 0) {
    if (this.howl.playing()) {
        const startVolume = this.howl.volume();
        this.howl.fade(startVolume, endVolume, 1);
    }
};

Audio.prototype.destroy = function () {
    this.howl.unload();
    this.howl = null;
};

Audio.prototype.unlock = function () {
    if (this.unlocked === true) {
        return;
    }

    // create empty buffer and play it
    const buffer = audioCtx.createBuffer(1, 1, 22050);
    const source = audioCtx.createBufferSource();

    source.buffer = buffer;
    source.connect(audioCtx.destination);
    source.noteOn(0);

    setTimeout(() => {
        if ((source.playbackState === source.PLAYING_STATE || source.playbackState === source.FINISHED_STATE)) {
            this.unlocked = true;
        }
    }, 0);
};

module.exports = Audio;



// WEBPACK FOOTER //
// ./js/lib/audio.js